import { use, useEffect, useState } from 'react';
import ErrorMessageProviderContext from 'shared/components/error/providers/contexts/error-message-context';

import MalfunctionNotification from '../domain/models/malfunction-notification';
import MalfunctionNotificationCommand from '../domain/models/malfunction-notification-command';
import { useGetMalfunctionNotifications, useUpsertMalfunctionNotifications } from './malfunction-notification-settings-queries';

export interface IMalfunctionNotificationSettingsHook {
  malfunctionNotifications: MalfunctionNotification[];
  malfunctionNotificationIsLoading: boolean;

  handleSave: (command: MalfunctionNotificationCommand) => void;
}

const useMalfunctionNotificationSettings = (): IMalfunctionNotificationSettingsHook => {
  const { setErrorMessage } = use(ErrorMessageProviderContext);
  const [malfunctionNotifications, setMalfunctionNotifications] = useState<MalfunctionNotification[]>([]);

  const {
    data: malfunctionNotificationesponse,
    error: malfunctionNotificationError,
    isError: malfunctionNotificationIsError,
    isLoading: malfunctionNotificationIsLoading,
  } = useGetMalfunctionNotifications();

  const {
    mutate: upsertMalfunctionNotifications,
    error: upsertMalfunctionNotificationsError,
    isError: upsertMalfunctionNotificationsIsError,
  } = useUpsertMalfunctionNotifications();

  const handleSave = (command: MalfunctionNotificationCommand) => {
    upsertMalfunctionNotifications(command);
  };

  useEffect(() => {
    if (malfunctionNotificationesponse?.malfunctionNotifications) {
      setMalfunctionNotifications(malfunctionNotificationesponse.malfunctionNotifications);
    }
  }, [malfunctionNotificationesponse]);

  useEffect(() => {
    const error =
      (malfunctionNotificationError as Error | string | undefined) || (upsertMalfunctionNotificationsError as Error | string | undefined);
    if ((malfunctionNotificationIsError || upsertMalfunctionNotificationsIsError) && error && typeof error === 'object') {
      setErrorMessage(error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [malfunctionNotificationIsError, upsertMalfunctionNotificationsIsError]);

  return {
    malfunctionNotifications,
    malfunctionNotificationIsLoading,

    handleSave,
  };
};

export default useMalfunctionNotificationSettings;
